import { atom } from "recoil";

export const pdfRef = atom({
  key: "pdfRef",
  default: null,
});

export const pageState = atom({
  key: "pageState",
  default: {
    currentPage: 1,
    totalPages: 0,
  },
});

export const pdfPage = atom({
  key: "pdfPage",
  default: null,
});

export const scaleValue = atom({
  key: "scaleValue",
  default: 1,
});

export const thumnail = atom({
  key: "thumnail",
  default: false,
});

export const mobileCurrentPage = atom({
  key: "mobileCurrentPage",
  default: 1,
});

export const mobileInputPage = atom({
  key: "mobileInputPage",
  default: 1,
});

export const openMobileMenu = atom({
  key: "openMobileMenu",
  default: false,
});

export const HandleHelp = atom({
  key: "HandleHelp",
  default: true,
});
